window.matchMedia("print").addEventListener("change", (e) => {
  if (e.matches) {
    document.querySelectorAll("details").forEach((details) => {
      details.open = true;
    });
  }
});